module.exports = __webpack_public_path__ + "img/placeholder-media.c26e9047.jpeg";